import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NbMenuItem } from '@nebular/theme';

@Injectable({
  providedIn: 'root',
})
/**
 * Service methods to translate some part of the application like NbMenus or SmartTable Configurations
 * TODO Generalize some translate methods used in smart table components
 */
export class AppTranslateService {

  constructor(private translateService: TranslateService) { }

  /**
   * Translate the given NbMenuItem and save translation key in data
   * to provide a new translation on language changes
   *
   * @param menuItem
   */
  translateMenuItem( menuItem: NbMenuItem ) {
    if ( menuItem.children != null ) {
      menuItem.children.forEach( item => this.translateMenuItem( item ) );
    }

    if (menuItem.data.title === undefined) {
      menuItem.data.title = menuItem.title;
      menuItem.title = this.translateService.instant( menuItem.title );
    } else {
      menuItem.title = this.translateService.instant( menuItem.data.title );
    }
  }

  /**
   * Translate all items of the Given NbMenu and save translation key in their data
   * to provide new translations on language changes
   *
   * @param menu
   */
  translateMenuItems(menu: NbMenuItem[]) {
    menu.forEach( item => {
      this.translateMenuItem( item );
    });
  }
}
